const callerIdSpoofing = {
  slug: 'caller-id-spoofing',
  title: 'Caller ID spoofing explained',
  description:
    'Why the number on your phone can be fake, and how to use number lookup and community reports wisely.',
  category: 'scams',
  guideType: 'overview',
  readMinutes: 4,
  partnerTip: 'none',
  relatedSlugs: ['verify-before-you-trust', 'smishing', 'common-phone-scams'],
  sections: [
    {
      type: 'paragraph',
      text: 'Caller ID is not a security feature. Scammers can make their call appear to come from your bank, a local area code, or even your own number.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Why scammers spoof numbers',
    },
    {
      type: 'list',
      items: [
        'Local numbers feel familiar and increase answer rates',
        'Impersonating a known brand builds false trust',
        'Returning a missed call from a spoofed number reaches the scammer, not the real business',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'How WhoDatNumber helps',
    },
    {
      type: 'paragraph',
      text: 'Community reports can show that many people received suspicious calls from the same number — even when that number looks legitimate. Reports are moderated and community-sourced; use them as one signal alongside verification.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'What spoofing does not prove',
    },
    {
      type: 'paragraph',
      text: 'A clean lookup does not guarantee a call is safe. A heavily reported number is a warning, not a court verdict. When in doubt, hang up and verify independently.',
    },
    {
      type: 'lookupCta',
    },
  ],
};

export default callerIdSpoofing;

